/* GENERADO — no editar aquí.
   Fuente: marca/produccion/simbolo.svg · simbolo-pequeno.svg
   Regenerar: pnpm brand:sync
   ------------------------------------------------------------------------- */

/** Maestro. Por encima de 32 px. */
export const SYMBOL = { viewBox: '0 0 48 48', d: 'M27.56,6.84 A20,20 0 0,0 17.21,45.48 Z M30.79,2.53 A20,20 0 0,1 20.44,41.16 Z' } as const;

/** Obligatorio por debajo de 32 px: el maestro se cierra a ese tamaño. */
export const SYMBOL_SMALL = { viewBox: '0 0 16 16', d: 'M8.81,3.04 A6,6 0 0,0 5.71,14.63 Z M10.29,1.37 A6,6 0 0,1 7.19,12.96 Z' } as const;

/** Umbral, en px, por debajo del cual se usa SYMBOL_SMALL. */
export const SYMBOL_SMALL_BELOW = 32;
